import type { ComponentChildren } from "preact";

interface TitledSectionProps {
  children: ComponentChildren;
  title: string;
  buttonData?: {
    label: string;
    onClick: () => void;
  };
}

export const TitledSection = ({
  title,
  buttonData,
  children,
}: TitledSectionProps) => {
  return (
    <div className="sb-today-titled-section">
      <div className={"sb-today-titled-section-header"}>
        <h5>{title}</h5>
        {buttonData && (
          <button onClick={buttonData.onClick}>{buttonData.label}</button>
        )}
      </div>
      {children}
    </div>
  );
};
